// extracted by mini-css-extract-plugin
module.exports = {"bottom":"MobileAppsBanner_bottom__AT8RP","slideUp":"MobileAppsBanner_slideUp__7qaX2"};